// Config for marketing consent toggle on sign up
export const marketingConsentActivated = true;
// Brand privacy url to be added
export const brandPrivacyPolicyUrl = 'https://www.brandback.de/privacy-policy';
